export const ROBINHOOD_CHAIN_ID = 4663;
export const ROBINHOOD_TESTNET_CHAIN_ID = 46630;
export const ROBINHOOD_RPC = "https://rpc.mainnet.chain.robinhood.com";
export const ROBINHOOD_EXPLORER = "https://robinhoodchain.blockscout.com";
export const WETH_ADDRESS = "0x0Bd7D308f8E1639FAb988df18A8011f41EAcAD73";
export const V3_FACTORY_ADDRESS = "0x1f7d7550B1b028f7571E69A784071F0205FD2EfA";
export const SWAP_ROUTER_ADDRESS = "0xCaf681a66D020601342297493863E78C959E5cb2";
export const POSITION_MANAGER_ADDRESS = "0x73991a25C818Bf1f1128dEAaB1492D45638DE0D3";
export const BOOST_PACKAGES = [
    { id: 0, durationHours: 1, priceEth: "0.03" },
    { id: 1, durationHours: 6, priceEth: "0.05" },
    { id: 2, durationHours: 12, priceEth: "0.07" },
    { id: 3, durationHours: 24, priceEth: "0.10" }
];
